import system from "system-components"

const Box = system(
  "width",
  "height",
  "display",
  "space",
  "fontSize",
  "color",
  "zIndex",

  "top",
  "bottom",
  "left",
  "right",

  "borders",
  "borderColor",
  "borderRadius",

  "flexDirection",
  "alignItems",
  "flexWrap",
  "flexDirection",
  "alignItems",
  "justifyContent",
  "flex",
  "order",
  "alignSelf",
  "justifySelf",

  "boxShadow"
)

Box.displayName = "Box"

export default Box



// WEBPACK FOOTER //
// ./src/components/Box.js